import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  label: string;
  id?: string;
  className?: string;
};
export function CTAButton({
  label,
  id,
  className = ''
}: CTAButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-3 rounded-2xl border-b-4 border-gold-dark bg-gold px-5 py-5 text-center font-extrabold uppercase leading-tight tracking-wide text-ink shadow-[0_12px_30px_-10px_rgba(143,108,56,0.7)] transition-[transform,background-color] duration-150 ease-out hover:bg-gold-light active:translate-y-0.5 focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50 text-[17px] sm:text-xl ${className}`} data-id="element-108" data-mp="2kwbpdyth92hr">
      <span data-id="element-109" data-mp="3cpksdzvg8nt6">{label}</span>
      <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-110" data-mp="3cp2pwli71dct" />
    </a>;
}